import {css} from 'lit'; export default css`:host{display:block;padding:8px}:host([selected]){background-color:rgba(0,0,0,.4)}`;
    